import { FtDatePipe } from './ft-date.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [FtDatePipe],
  providers: [FtDatePipe],
  exports: [FtDatePipe]
})
export class FtDatePipeModule { }
